import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {SolrEntityService} from "./solr-entity.service";
import {SolrOptionsEntityDTO, SolrPreviewTaxonomyEntityConfig} from "@signature-it/ngx-entity/models";

declare let _: any;
@Injectable({
    providedIn: 'root'
})

export class SolrTaxonomyService {
    taxonomy = {};
    openNodes = {};
    public toggleNode = new  BehaviorSubject({taxonomyVar: '', taxonomyNodeVar: ''});
    public setActiveNode$ = new  BehaviorSubject({taxonomyVar: '', list: []});

    constructor(protected solrEntityService: SolrEntityService,) {
    }

    initTaxonomy(taxonomy_var, config: SolrPreviewTaxonomyEntityConfig): Observable<any> {
        this.openNodes[taxonomy_var] = [];
        return new Observable((observer) => {
            const solrOptions = new SolrOptionsEntityDTO({
                itemsPerPage: 1000,
                filters: {'entity_tree_links_ss': taxonomy_var},
                sort: 'entity_tree_order_i+asc',
            });
            this.solrEntityService.getSolr(solrOptions).subscribe(res => {
                this.taxonomy[taxonomy_var] = {
                    'list': res['response']['docs'],
                    'config': config,
                }
                observer.next(true);
                observer.complete();
            })
        })

    }

   getChildren(taxonomy_var, node_var) {
        return this.taxonomy[taxonomy_var]['list'].filter(item => item['entity_tree_links_ss'][item['entity_tree_links_ss'].length -2] == node_var);
   }

   getTaxonomy(taxonomy_var, node_var) {
       return this.taxonomy[taxonomy_var]['list'].find(item => item['entity_var_s'] == node_var);
   }

   getFirstLevel(taxonomy_var) {
       return this.taxonomy[taxonomy_var]['list'].filter(item => item['entity_tree_links_ss'].length == 2);
   }

    getConfig(taxonomy_var) {
        return this.taxonomy[taxonomy_var]['config'];
    }

    deleteTaxonomy(taxonomy_var) {
        delete this.taxonomy[taxonomy_var];
        delete this.openNodes[taxonomy_var];
    }

    hasChildren(taxonomy_var, node_var) {
        return this.taxonomy[taxonomy_var]['list'].some(item => item['entity_tree_links_ss'][item['entity_tree_links_ss'].length -2] == node_var);
    }


    isOpenNode(taxonomy_var, node_var) {
        return this.openNodes[taxonomy_var].includes(node_var);
    }
}
